// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2025 Collab Digital Twins

import { RoleNames } from '../types/global'

import type { Role } from '../types/dbTypes'

const normalizeRoleName = (role?: string) => (role || '').trim().toLowerCase()

export const getNormalizedRoleNames = (userRoles?: Role[] | null) => {
  if (!Array.isArray(userRoles)) return []
  return userRoles
    .map(role => normalizeRoleName(role?.name))
    .filter(Boolean)
}

export const isAdminUser = (userRoles?: Role[] | null) =>
  // getNormalizedRoleNames() lowercases every role name, so the needle must be
  // lowercased too — RoleNames.admin is 'Admin' (capital A), which would never
  // match the lowercased list. (Bug found via unit test; helper was unused.)
  getNormalizedRoleNames(userRoles).includes(RoleNames.admin.toLowerCase())
